import React, { useState } from 'react';
import Modal from 'react-modal';
import { toast } from 'react-toastify';

export default function CreateAdditionalDocumentModal({
    parentId,
    onCancel,
    onSuccess,
    show,
}) {
    const [submitting, setSubmitting] = useState(false);
    const [file, setFile] = useState(null);

    const errorToaster = () => toast.error(<div>An error occurred, please try again</div>);

    const onConfirm = async () => {
        setSubmitting(true)

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await axios.post(route('web-api.additional-documents.store'),
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            if (200 <= response.status < 300) {
                onSuccess()
            } else {
                errorToaster()
            }
        } catch (exception) {
            console.log(exception)
            errorToaster()
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <Modal
            ariaHideApp={false}
            isOpen={show}
            parentSelector={() => document.getElementById(parentId)}
            onRequestClose={() => onCancel()}
            contentLabel={"Create Additional Document"}
            className={'ReactModal__Content react-modal-outer modal-dialog admin-modal allow-overflow'}
            style={{
                overlay: {
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    overflow: 'hidden',
                    outline: 'none',
                },
                content: {
                    width: "100%",
                    height: "100%",
                    padding: 0,
                    border: 0,
                    outline: 'none',
                },
            }}
        >
            <div className="p-4 modal-content">
                <div className="modal-header border-0 m-0 p-0 pb-4">
                    <h4 className="modal-title text-eh-navy">{"Create Additional Document"}</h4>
                    <button
                        type="button" className="close"
                        data-dismiss="modal" aria-label="Close"
                        onClick={onCancel}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body m-0 mb-3 p-0">
                    <div className="form-group form-inline">
                        <input
                            type="file"
                            accept=".pdf"
                            className='border-0'
                            style={{maxWidth: "100%"}}
                            onChange={(event) => setFile(event.target.files[0])}
                        />
                    </div>
                </div>
                <div className="modal-footer m-0 p-0 d-flex gap-4 border-0">
                    <button
                        type="button"
                        data-dismiss="modal"
                        className="btn btn-outline-eh-off-black px-3 mr-3"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn btn-eh-lilac py-0 px-3 ml-0 py-0"
                        onClick={onConfirm}
                        disabled={submitting || file === null}
                    >
                        Create
                    </button>
                </div>
            </div>
        </Modal>
    );
}
